import { useTheme, useMediaQuery } from '@material-ui/core'

/** @typedef {'up' | 'down' | 'between'} MediaQuery */

/**
 *
 * @param {MediaQuery} query
 * @param {number | import('@material-ui/core/styles/createBreakpoints').Breakpoint} start
 * @param {number | import('@material-ui/core/styles/createBreakpoints').Breakpoint | undefined} end
 * @returns
 */
export function useResponsive(query, start, end) {
  const theme = useTheme()

  const mediaUp = useMediaQuery(theme.breakpoints.up(start))

  const mediaDown = useMediaQuery(theme.breakpoints.down(start))

  const mediaBetween = useMediaQuery(theme.breakpoints.between(start, end))

  const mediaOnly = useMediaQuery(theme.breakpoints.only(start))

  if (query === 'up') {
    return mediaUp
  }

  if (query === 'down') {
    return mediaDown
  }

  if (query === 'between') {
    return mediaBetween
  }

  return mediaOnly
}
